var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApartmentWhite = function SvgApartmentWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.357 5.571V23.25h12.054v-3.91M2.357 5.57h12.054m-12.054 0H.75v-2.41h4.018m9.643 2.41V19.34m0-13.768h7.232M14.41 19.34h6.428m0 0v3.911h2.411H.75m20.09-3.91h.803V5.57m0 0h1.607v-2.41H12m0 0V.75H4.768v2.41m7.232 0H4.768m5.41 17.25V16.5h-3.91v3.91zm0-7.82V8.678h-3.91v3.91z"
  })));
};
export default SvgApartmentWhite;